// extracted by mini-css-extract-plugin
module.exports = {"attendeesWrap":"AttendeesUser_attendeesWrap__3YGWF","attendeesName":"AttendeesUser_attendeesName__1nZq5","attendeesPosition":"AttendeesUser_attendeesPosition__VLnV6"};